// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2c084d23","510":"c8daac8e","812":"8aade368"}[chunkId] + ".chunk.js";
};